import type { ISEOProps } from "../types/core";

export const ChooseUserTypePageSEO: ISEOProps = {
  title: "Choose Account Type - Sugar Cribs",
  description:
    "Select your account type on Sugar Cribs - become a content creator or viewer to access exclusive content and features.",
};
